import { render, staticRenderFns } from "./ClientCMSContainer.vue?vue&type=template&id=b95720c0&scoped=true&"
import script from "./ClientCMSContainer.vue?vue&type=script&lang=js&"
export * from "./ClientCMSContainer.vue?vue&type=script&lang=js&"
import style0 from "./ClientCMSContainer.vue?vue&type=style&index=0&id=b95720c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95720c0",
  null
  
)

export default component.exports